import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetchPromos = () => {

    const [promos, setPromos] = useState([]);
    const fetch = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/client/me/promos`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
            }})
            .then(({ data }) => {
                setPromos(data);
            })
            .catch((err) => {
                setPromos([]);
            });
    }
    useEffect(() => {
        fetch()
    }, []);

    return { promos, fetch }
}

export default useFetchPromos;